import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenuBarMobile = _resolveComponent("MainMenuBarMobile")!
  const _component_MainMenuBar = _resolveComponent("MainMenuBar")!

  return (_ctx.isSmallScreen)
    ? (_openBlock(), _createBlock(_component_MainMenuBarMobile, { key: 0 }))
    : (_openBlock(), _createBlock(_component_MainMenuBar, { key: 1 }))
}